import { Label, Text, PrimaryButton, Stack, useTheme } from '@fluentui/react';
import * as React from 'react';
import { EventPriceTypeEnum } from '../../../Models/Event/EventPriceTypeEnum';
import { EventTypeEnum } from '../../../Models/Event/EventTypeEnum';
import { IEvent } from '../../../Models/Event/IEvent';

interface INewOrderStepEventProps {
    event?: IEvent;
    goToStep: (stepId: number) => void;
    isAuth: boolean;
}


export const NewOrderStepEvent: React.FunctionComponent<INewOrderStepEventProps> = (props) => {

    const theme = useTheme();
    const goToNextStep = () => {
        if (props.isAuth === true) {
            props.goToStep(3);
        }
        else {
            props.goToStep(2);
        }
    }
    const totalPrice = () => {
        return (<Stack styles={{ root: { paddingTop: 5, paddingBottom: 5 } }}>
            {props.event && props.event.priceType === EventPriceTypeEnum.ByEvent ?
                <Label>Cena celkem za akci: {props.event.price},- Kč</Label>
                : null}
            {props.event && props.event.priceType === EventPriceTypeEnum.BySemester ?
                <Stack>
                    <Label>Cena za:</Label>
                    {props.event.firstSemesterPrice == props.event.secondSemesterPrice ?
                        <Label>Pololetí: {props.event.firstSemesterPrice},- Kč</Label>
                        :                         
                        <>
                            <Label>První pololetí: {props.event.firstSemesterPrice},- Kč</Label>
                            <Label>Druhé pololetí: {props.event.secondSemesterPrice},- Kč</Label>
                        </>
                    }
                </Stack>
                : null}

        </Stack>)
    }

    return (<Stack>
        <h2>Na co se to vlastně hlásím ? </h2>
        {props.event ?
            <Stack styles={{ root: { width: '100%', maxWidth: 800 } }}>
                <Label styles={{
                    root: {
                        fontFamily: "Comfortaa, serif", color: theme.palette.blue
                    }
                }}>{props.event?.name}</Label>
                <Text styles={{ root: { fontStyle: "italic" } }}>{props.event?.description}</Text>
                <Label>{(props.event.eventTypeEnum === EventTypeEnum.Training ? "Hodinová dotace kurzu:" : "Počet lekcí:")} {props.event?.numberOfLessons + (props.event.priceType === EventPriceTypeEnum.BySemester ? " (pololetí)" : " vyuč. hodin")} </Label>
                <Label>Místo konání: {props.event?.roomName + (props.event?.roomDistrict? ", "+ props.event?.roomDistrict:"")}</Label>

                <Label>Věková skupina: {props.event?.ageGroupName}</Label>
                <Label>Školní rok: {props.event?.schoolYear}-{props.event.schoolYear + 1}</Label>
                {totalPrice()}
                <Stack horizontal wrap horizontalAlign="center" tokens={{ childrenGap: 10 }} styles={{ root: { paddingTop: 20 } }}>
                    <PrimaryButton disabled={!props.event} text="Pokračovat" onClick={() => { goToNextStep(); }} />
                </Stack>
            </Stack>

            : null}
    </Stack>)
}
